<template>
  <section class="section-padding">
    <div class="container">
      <div class="mb-4">
        <b-button tag="router-link" :to="{ name: 'meetings' }" icon-left="arrow-left" type="is-text">Volver a reuniones</b-button>
      </div>
      <div class="box" v-if="meeting">
        <div class="is-flex is-justify-content-space-between is-align-items-center mb-2">
          <div>
            <p class="has-text-grey has-text-weight-semibold is-uppercase is-size-7">Reunión</p>
            <h1 class="title is-3 mb-5">{{ meeting.titulo }}</h1>
            <p class="subtitle is-6 mb-5">
              <b-icon icon="calendar" size="is-small"></b-icon>
              <span class="ml-1">{{ meeting.fecha || 'Fecha por definir' }}</span>
              <span class="mx-2">|</span>
              <b-icon icon="map-marker" size="is-small"></b-icon>
              <span class="ml-1">{{ meeting.lugar || 'Lugar por definir' }}</span>
            </p>
            <b-tag :type="meeting.activo ? 'is-success is-light' : 'is-warning is-light'">
              {{ meeting.activo ? 'Activada' : 'Desactivada' }}
            </b-tag>
          </div>
          <div v-if="meeting.portada" class="image is-128x128">
            <img class="is-rounded" :src="meeting.portada" :alt="meeting.titulo" />
          </div>
        </div>
        <b-tabs expanded>
          <b-tab-item label="Información general">
            <GeneralInfo :meeting="meeting" @updated="refreshMeeting"></GeneralInfo>
          </b-tab-item>
          <b-tab-item label="Invitados" :disabled="!meeting">
            <Guests :meeting-id="meeting.id"></Guests>
          </b-tab-item>
        </b-tabs>
      </div>
      <div v-else class="box has-text-centered">
        <p class="title is-5">Cargando reunión...</p>
        <p class="has-text-grey is-size-7">Verifica la URL si la vista no se actualiza.</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import GeneralInfo from '../components/general-info.vue';
import Guests from '../components/guests.vue';

export default {
  components: {
    GeneralInfo,
    Guests,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      meeting: (state) => state.meetings.currentMeeting,
    }),
  },
  async mounted() {
    await this.loadMeeting();
  },
  watch: {
    '$route.params.id': {
      async handler() {
        await this.loadMeeting();
      },
    },
  },
  methods: {
    ...mapActions({
      fetchMeeting: 'meetings/fetchMeeting',
    }),
    async loadMeeting() {
      this.loading = true;
      const found = await this.fetchMeeting(this.$route.params.id);
      this.loading = false;

      if (!found) {
        this.$buefy.toast.open({
          message: 'No encontramos la reunión solicitada.',
          type: 'is-danger',
        });
        this.$router.push({ name: 'meetings' });
      }
    },
    async refreshMeeting(updated) {
      if (updated?.id) {
        await this.fetchMeeting(updated.id);
      }
    },
  },
};
</script>

<style scoped>
.subtitle .icon {
  vertical-align: middle;
}
</style>
